var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.98,
    height: 10.689,
    viewBox: "0 0 19.98 10.689",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#45338c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-854.376,1105.812a1.466,1.466,0,0,1,.139.386c.023.231-.016.467-.006.7.012.262.049.523.076.785.219-.042.51-.012.643-.142a2.849,2.849,0,0,1,.957-.446c.869-.4,1.736-.809,2.594-1.232a17.6,17.6,0,0,0,2.837-1.585,4.908,4.908,0,0,1,1.047-.418c.226-.1.435-.228.657-.334.572-.275,1.148-.542,1.72-.816.151-.073.291-.17.442-.243.4-.194.8-.4,1.209-.568,1.11-.464,2.235-.894,3.335-1.38a5.3,5.3,0,0,1,1.176-.5c.334-.063.427.089.444.287a6.035,6.035,0,0,1-.05,1.04c-.061.665-.649.911-1.089,1.208a15.758,15.758,0,0,1-2.033,1.058c-.348.167-.733.256-1.08.424-.216.1-.377.322-.591.434-.35.183-.735.3-1.085.482-.439.229-.858.5-1.286.749-.3.175-.6.358-.9.521-.713.38-1.439.736-2.143,1.131-.571.319-1.1.711-1.679,1.016-.693.367-1.417.678-2.127,1.013-.013.006-.034.005-.041.015-.446.619-1.2.525-1.807.764a8.929,8.929,0,0,1-1.808.507,2.066,2.066,0,0,1-1.584-.42.748.748,0,0,1-.311-.59c-.054-.486-.2-.962-.282-1.446a4.957,4.957,0,0,1,.131-2.253c.136-.461.876-1.05,1.325-.948.29.066.53.349.793.535Z",
    transform: "translate(857.076 -1100.003)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick9);
export default __webpack_public_path__ + "static/media/tick-9.3045fbb06650dab352298c7066615b1a.svg";
export { ForwardRef as ReactComponent };